import { PlayerActionType } from 'enums';

export const setIsPlaying = (isPlaying: boolean) =>
  ({ type: PlayerActionType.SET_IS_PLAYING, isPlaying } as const);
export const setEndTime = (endTime: number) =>
  ({ type: PlayerActionType.SET_END_TIME, endTime } as const);
